import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchTournamentsWithPrizeStatus } from "../../../../features/prizeDelivery/prizeDeliverySlice";
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import { getLocalizedTime } from "../../../../utils/timeZone";
import styles from "./prizeDelivery.module.css";
import WinnersList from "./winnersList/WinnersList";

const PrizeDelivery = () => {
  const [selectedTournament, setSelectedTournament] = useState("");

  const dispatch = useDispatch();

  const finishedTournamentListRef = useRef();

  const { tournamentsWithPrizeStatus, fetchWithPrizeStatus } = useSelector(
    (state) => state.prizeDelivery
  );
  const { timeZone } = useSelector((state) => state.timeZone);

  const displayTournaments = tournamentsWithPrizeStatus.map((item) => {
    const localizedStartDate = getLocalizedTime(item.startDate, timeZone);
    const isAllDelivered = item.prizeStatuses.every(
      (item) => item.hasReceivedPrize === true
    );

    return (
      <div
        key={item._id}
        className={
          selectedTournament === item._id && isAllDelivered
            ? `${styles.tournamentWrapper} ${styles.activeDelivered}`
            : isAllDelivered
            ? `${styles.tournamentWrapper} ${styles.delivered}`
            : selectedTournament === item._id && !isAllDelivered
            ? `${styles.tournamentWrapper} ${styles.active}`
            : styles.tournamentWrapper
        }
        onClick={() => setSelectedTournament(item._id)}
      >
        <TextWrapper textStyle={"textMid"}>الاسم : {item.name}</TextWrapper>
        <TextWrapper textStyle={"textMid"}>
          الرقم التسلسلي : {item.serialNumber}
        </TextWrapper>
        <TextWrapper textStyle={"textMid"}>الحالة : {item.status}</TextWrapper>
        <TextWrapper textStyle="textMid">
          تبدأ من تاريخ : {localizedStartDate.toLocaleString().split(",")[0]}
        </TextWrapper>
      </div>
    );
  });

  useInfiniteScroll({
    ref: finishedTournamentListRef,
    hasMore: fetchWithPrizeStatus.hasMore,
    isLoading: fetchWithPrizeStatus.status === "loading",
    onLoadMore: () => {
      dispatch(
        fetchTournamentsWithPrizeStatus({
          page: fetchWithPrizeStatus.page + 1,
        })
      );
    },
  });

  useEffect(() => {
    if (fetchWithPrizeStatus.status === "idle") {
      dispatch(fetchTournamentsWithPrizeStatus({ page: 1 }));
    }
  }, [dispatch, fetchWithPrizeStatus.status]);

  return (
    <div className={styles.container}>
      <TextWrapper textStyle="textTitle">تسليم الجوائز</TextWrapper>
      <div className={styles.displayContainerWrapper}>
        <DisplayContainer>
          <div className={styles.prizeDeliveryContainer}>
            <div
              className={styles.tournamentsWrapper}
              ref={finishedTournamentListRef}
            >
              <TextWrapper textStyle={"textMid"}>البطولات المنتهية</TextWrapper>
              {displayTournaments}
              {fetchWithPrizeStatus.status === "loading" && (
                <div className={styles.loaderContainer}>
                  <Loader />
                </div>
              )}
            </div>
            {selectedTournament && (
              <WinnersList selectedTournament={selectedTournament} />
            )}
          </div>
        </DisplayContainer>
      </div>
    </div>
  );
};

export default PrizeDelivery;
